import { http } from '@packet/management/src/api/http';
import type { CreateRoleRequest, UpdateRoleRequest, GetRoleListRequest, GetRoleListResponse, GetRoleDetailRequest, GetRoleDetailResponse, DeleteRoleRequest } from '../../DTO/role';
import type { ApiResponse } from '../../DTO/common';

/**
 * 获取角色列表
 */
export const getRoleList = async (params: GetRoleListRequest): Promise<ApiResponse<GetRoleListResponse>> => {
  return http().get('/api/v1/roles/list', params);
};

/**
 * 创建角色
 */
export const createRole = async (data: CreateRoleRequest): Promise<ApiResponse<null>> => {
  return http().post('/api/v1/roles/create', data);
};

/**
 * 更新角色
 */
export const updateRole = async (data: UpdateRoleRequest): Promise<ApiResponse<null>> => {
  return http().put('/api/v1/roles/update', data);
};

/**
 * 删除角色
 */
export const deleteRole = async (params: DeleteRoleRequest): Promise<ApiResponse<null>> => {
  return http().del(`/api/v1/roles/delete?id=${params.id}`);
};

/**
 * 获取角色详情
 */
export const getRoleDetail = async (params: GetRoleDetailRequest): Promise<ApiResponse<GetRoleDetailResponse>> => {
  return http().get('/api/v1/roles/get', params);
};
